/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCircuitCellPlus = createReactComponent("outline", "circuit-cell-plus", "IconCircuitCellPlus", [["path", { "d": "M2 12h9", "key": "svg-0" }], ["path", { "d": "M15 12h7", "key": "svg-1" }], ["path", { "d": "M11 5v14", "key": "svg-2" }], ["path", { "d": "M15 9v6", "key": "svg-3" }], ["path", { "d": "M3 5h4", "key": "svg-4" }], ["path", { "d": "M5 3v4", "key": "svg-5" }]]);

export { IconCircuitCellPlus as default };
//# sourceMappingURL=IconCircuitCellPlus.mjs.map
